import DeleteVideo from "./DeleteVideo";
export default DeleteVideo;
